export enum AuthStatus {
	LOGGED_OUT = 'logged_out',
	LOGGED_IN = 'logged_in',
	ERROR = 'error'
}